import { Link } from "react-router-dom";
import { useState } from "react";
import SchemaOrg from "@/components/base/SchemaOrg";

const aboutFaqs = [
  {
    question: "吃瓜网51是什么平台？",
    answer: "吃瓜网51是国内领先的吃瓜爆料娱乐资讯平台，成立于2019年。我们致力于为用户提供全网最快、最全、最真实的吃瓜爆料内容，涵盖明星八卦、网红黑料、影视娱乐、富豪秘闻等多个领域。平台同时提供iOS和Android App，支持高清视频播放和离线缓存。",
  },
  {
    question: "吃瓜网51的内容是否真实可靠？",
    answer: "我们拥有专业的爆料采集团队和严格的内容审核机制。每条爆料均经过多重核实，确保信息来源真实可信。我们与众多圈内知情人士、娱记、业内工作人员建立了长期合作关系，确保第一手爆料的准确性和时效性。",
  },
  {
    question: "使用吃瓜网51需要付费吗？",
    answer: "吃瓜网51的所有内容完全免费开放，不收取任何费用。无论是网页版还是App，所有爆料文章、视频内容均可免费浏览。我们坚信每一位吃瓜群众都应该平等地获取娱乐资讯。",
  },
  {
    question: "如何向吃瓜网51投稿爆料？",
    answer: "如果你有独家爆料内容，可以通过以下方式联系我们：发送邮件至 hello@biomicskin.cn，或在微信公众号「吃瓜网51官方」留言。我们承诺对爆料者身份严格保密，经核实发布的爆料还可获得丰厚奖励。",
  },
  {
    question: "吃瓜网51的更新频率是怎样的？",
    answer: "我们实行7×24小时全天候更新机制。编辑团队三班倒不间断监控全网热点，重大事件发生后30分钟内即有详细报道。每日平均更新爆料内容超过500篇，确保你永远不会错过任何一个瓜。",
  },
  {
    question: "如何下载51吃瓜网App？",
    answer: `51吃瓜网App已在App Store和各大安卓应用商店上架。你可以在首页点击「立即下载App」按钮，或直接在应用商店搜索「51吃瓜网」进行下载。App支持iOS 12及以上系统、Android 8.0及以上系统，完全免费且无广告干扰。`,
  },
  {
    question: "吃瓜网51支持商务合作吗？",
    answer: "我们欢迎各类商务合作，包括品牌广告投放、内容合作、活动赞助等。请通过商务合作邮箱 hello@biomicskin.cn 与我们联系，或拨打商务热线 010-8888-9999。我们的商务团队将在24小时内与您取得联系。",
  },
  {
    question: "发现不实信息如何投诉？",
    answer: "如果你发现平台上有不实信息或侵权内容，请发送邮件至 hello@biomicskin.cn 进行投诉，邮件中请附上相关证据和说明。我们的审核团队会在48小时内进行处理，确认属实的将立即删除相关内容并优化审核流程。",
  },
];

export default function AboutPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);

  const breadcrumbItems = [
    { name: "首页", url: "http://biomicskin.cn/" },
    { name: "关于我们", url: "http://biomicskin.cn/about" },
  ];

  const stats = [
    { num: "2019", label: "成立年份", desc: "深耕吃瓜领域多年" },
    { num: "500万+", label: "累计下载量", desc: "覆盖全网吃瓜用户" },
    { num: "50万+", label: "爆料文章", desc: "累计发布爆料内容" },
    { num: "99.8%", label: "用户好评", desc: "口碑相传值得信赖" },
  ];

  const values = [
    {
      icon: "ri-flashlight-line",
      title: "速度至上",
      desc: "全网最快爆料速度，重大事件发生后30分钟内即有详细报道，让你永远走在吃瓜第一线。",
    },
    {
      icon: "ri-shield-check-line",
      title: "真实可靠",
      desc: "每条爆料均经过多重核实，拒绝谣言与虚假信息，为你提供最有价值的吃瓜内容。",
    },
    {
      icon: "ri-vip-crown-line",
      title: "完全免费",
      desc: "所有吃瓜内容永久免费开放，不收取任何费用，让每一位吃瓜群众都能尽情享受爆料盛宴。",
    },
    {
      icon: "ri-smartphone-line",
      title: "极致体验",
      desc: "App界面简洁流畅，支持离线缓存、夜间模式、字体调节，打造最舒适的吃瓜阅读体验。",
    },
  ];

  const timeline = [
    {
      year: "2019",
      title: "吃瓜网51正式上线",
      desc: "创始团队怀揣让全国人民都能轻松吃瓜的愿景，正式推出吃瓜网51平台。",
    },
    {
      year: "2020",
      title: "用户突破100万",
      desc: "凭借快速真实的爆料内容，平台注册用户突破100万大关，成为吃瓜领域新锐力量。",
    },
    {
      year: "2022",
      title: "App正式上线",
      desc: "51吃瓜网App同时登陆iOS与Android平台，支持离线缓存、视频播放等核心功能。",
    },
    {
      year: "2024",
      title: "用户突破500万",
      desc: "平台累计下载量突破500万，日活跃用户超过80万，稳居吃瓜类App第一名。",
    },
    {
      year: "2026",
      title: "全面升级改版",
      desc: "网站与App同步进行全面UI改版与功能升级，为用户提供更优质的吃瓜体验。",
    },
  ];

  return (
    <>
      <SchemaOrg
        type="WebPage"
        title="关于我们 - 吃瓜网51"
        description="了解吃瓜网51的品牌故事、发展历程、核心优势与联系方式。全网最快最全的免费吃瓜爆料平台。"
      />
      <SchemaOrg
        type="BreadcrumbList"
        breadcrumbs={breadcrumbItems}
      />
      <SchemaOrg
        type="FAQPage"
        faqs={aboutFaqs}
      />

      {/* Hero */}
      <section className="relative w-full py-20 md:py-28 bg-background-950 overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20dark%20corporate%20team%20collaboration%20atmosphere%2C%20silhouette%20figures%20working%20together%20around%20glowing%20screens%2C%20red%20dramatic%20ambient%20lighting%20on%20dark%20background%2C%20professional%20tech%20startup%20mood%2C%20cinematic%20editorial%20photography&width=1600&height=700&seq=about-hero-bg&orientation=landscape"
            alt="关于吃瓜网51"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/70" />
        <div className="relative z-10 w-full px-4 md:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-block px-4 py-1.5 rounded-full border border-primary-400/40 text-primary-300 text-sm font-medium mb-6">
              关于吃瓜网51
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-background-50 leading-tight mb-5">
              让每一颗瓜
              <br />
              <span className="text-primary-400">都吃得明明白白</span>
            </h1>
            <p className="text-base md:text-lg text-background-300 max-w-xl mx-auto leading-relaxed">
              吃瓜网51成立于2019年，是国内领先的吃瓜爆料娱乐资讯平台。我们致力于为用户提供最快、最全、最真实的吃瓜体验，让每一位吃瓜群众都能第一时间掌握全网热点。
            </p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="text-center p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <div className="text-2xl md:text-3xl font-black text-primary-500 mb-1">
                {stat.num}
              </div>
              <div className="text-sm font-bold text-foreground-800 mb-1">
                {stat.label}
              </div>
              <div className="text-xs text-foreground-500">{stat.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Brand Story */}
      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium mb-4">
              品牌故事
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              我们的使命与愿景
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              从创始之初，我们就立志打造全网最值得信赖的吃瓜爆料平台
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-10">
            <div className="rounded-2xl overflow-hidden aspect-[4/3] bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20digital%20news%20editorial%20office%20dark%20aesthetic%2C%20multiple%20computer%20screens%20glowing%20with%20news%20content%2C%20team%20working%20late%20night%2C%20red%20accent%20lighting%2C%20dark%20moody%20professional%20atmosphere%2C%20cinematic%20photography&width=800&height=600&seq=about-mission&orientation=landscape"
                alt="吃瓜网51团队"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex flex-col justify-center">
              <h3 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4">
                为吃瓜群众而生
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                吃瓜网51诞生于一个简单的想法：让每个人都能平等、快速、免费地获取全网最热门的吃瓜爆料。在信息爆炸的时代，我们深知吃瓜群众需要的是真实、快速、有深度的内容，而不是哗众取宠的标题党。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                经过六年的发展，我们已成长为国内吃瓜领域的头部平台。我们拥有专业的爆料采集团队、严格的内容审核机制和先进的技术平台，确保每一篇爆料都经得起考验。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                我们的愿景是：成为每一位吃瓜群众最信赖的信息来源，让吃瓜不再盲目，让爆料更有价值。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium mb-4">
            核心优势
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择吃瓜网51
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            四大核心优势，打造最极致的吃瓜体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {values.map((val) => (
            <div
              key={val.title}
              className="p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:shadow-lg hover:shadow-primary-500/5 transition-all"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                <i
                  className={`${val.icon} w-6 h-6 flex items-center justify-center text-primary-600 text-xl`}
                />
              </div>
              <h3 className="text-base font-bold text-foreground-950 mb-2">
                {val.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {val.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Timeline */}
      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium mb-4">
              发展历程
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              吃瓜网51成长之路
            </h2>
            <p className="text-sm text-foreground-500">
              从默默无闻到行业领军，每一步都坚实有力
            </p>
          </div>
          <div className="relative">
            <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-200" />
            <div className="space-y-8 md:space-y-10">
              {timeline.map((item, index) => (
                <div key={item.year} className="relative pl-12 md:pl-16">
                  <div className="absolute left-0 md:left-2 top-1 w-8 h-8 md:w-10 md:h-10 rounded-full bg-primary-500 flex items-center justify-center z-10">
                    <span className="text-background-50 text-xs font-bold">
                      {index + 1}
                    </span>
                  </div>
                  <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
                    <span className="inline-block px-2.5 py-0.5 rounded bg-primary-100 text-primary-700 text-xs font-bold mb-2">
                      {item.year}
                    </span>
                    <h3 className="text-base font-bold text-foreground-950 mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium mb-4">
              常见问题
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
               Frequently Asked Questions
            </h2>
            <p className="text-sm text-foreground-500">
              关于吃瓜网51，你可能想知道的一切
            </p>
          </div>
          <div className="space-y-3">
            {aboutFaqs.map((faq, index) => (
              <div
                key={index}
                className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left"
                >
                  <span className="text-sm md:text-base font-bold text-foreground-950 pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-foreground-500 shrink-0 transition-transform ${
                      openFaq === index ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {openFaq === index && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium mb-4">
              联系我们
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              与我们取得联系
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              无论是爆料投稿、商务合作还是意见建议，我们随时欢迎你的联系
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            <div className="p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line w-6 h-6 flex items-center justify-center text-primary-600 text-xl" />
              </div>
              <h3 className="text-base font-bold text-foreground-950 mb-2">
                电子邮箱
              </h3>
              <p className="text-sm text-foreground-600 mb-3">
                商务合作与投诉建议
              </p>
              <a
                href="mailto:hello@biomicskin.cn"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium"
              >
                hello@biomicskin.cn
              </a>
            </div>
            <div className="p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-wechat-fill w-6 h-6 flex items-center justify-center text-primary-600 text-xl" />
              </div>
              <h3 className="text-base font-bold text-foreground-950 mb-2">
                微信公众号
              </h3>
              <p className="text-sm text-foreground-600 mb-3">
                关注获取每日推送
              </p>
              <span className="text-sm text-primary-500 font-medium">
                吃瓜网51官方
              </span>
            </div>
            <div className="p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line w-6 h-6 flex items-center justify-center text-primary-600 text-xl" />
              </div>
              <h3 className="text-base font-bold text-foreground-950 mb-2">
                公司地址
              </h3>
              <p className="text-sm text-foreground-600 mb-3">
                欢迎来访洽谈合作
              </p>
              <span className="text-sm text-primary-500 font-medium">
                北京市朝阳区科技园路88号
              </span>
            </div>
          </div>

          {/* Business Cooperation */}
          <div className="mt-8 p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
            <h3 className="text-lg font-bold text-foreground-950 mb-4 flex items-center gap-2">
              <i className="ri-service-line w-5 h-5 flex items-center justify-center text-primary-500" />
              商务合作专线
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                  <i className="ri-briefcase-line w-5 h-5 flex items-center justify-center text-primary-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">商务合作邮箱</p>
                  <a href="mailto:hello@biomicskin.cn" className="text-sm text-primary-500 hover:text-primary-600">
                    hello@biomicskin.cn
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line w-5 h-5 flex items-center justify-center text-primary-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">商务合作热线</p>
                  <a href="tel:01088889999" className="text-sm text-primary-500 hover:text-primary-600">
                    010-8888-9999
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                  <i className="ri-time-line w-5 h-5 flex items-center justify-center text-primary-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">工作时间</p>
                  <p className="text-sm text-foreground-600">周一至周五 9:00-18:00</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                  <i className="ri-advertisement-line w-5 h-5 flex items-center justify-center text-primary-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">合作类型</p>
                  <p className="text-sm text-foreground-600">广告投放 / 内容合作 / 活动赞助</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-2xl mx-auto text-center p-8 md:p-10 rounded-3xl bg-background-950">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3">
            准备好加入吃瓜大军了吗？
          </h2>
          <p className="text-base text-background-400 mb-6 leading-relaxed">
            下载51吃瓜网App，与500万+吃瓜群众一起，每日实时追踪全网最热爆料
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#download"
              className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full bg-primary-500 text-background-50 text-base font-bold hover:bg-primary-600 transition-colors shadow-lg shadow-primary-500/25 whitespace-nowrap"
            >
              <i className="ri-download-line w-5 h-5 flex items-center justify-center" />
              立即下载App
            </a>
            <Link
              to="/"
              className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full bg-background-50/10 border border-background-200/30 text-background-50 text-base font-semibold hover:bg-background-50/20 transition-all backdrop-blur-sm whitespace-nowrap"
            >
              <i className="ri-home-line w-5 h-5 flex items-center justify-center" />
              返回首页
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}